import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const NavBarContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  minWidth: 0,
  flex: 1,
  paddingLeft: theme.spacing(8),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(2.5),
  },
  [theme.breakpoints.down('lg')]: {
    // Room for the right-aligned Share/Print/Data cluster on the same row.
    paddingRight: 0,
  },
}));

export const HeaderValue = styled('div')(({ theme }) => ({
  paddingLeft: theme.spacing(0.2),
}));
